/**
 * UI Configuration
 * Centralized configuration for UI features and thresholds
 */

/**
 * Account Groups Settings
 */
/** When groups.length > VISIBLE_GROUPS_COUNT, scrolling is enabled and only VISIBLE_GROUPS_COUNT are visible */
const VISIBLE_GROUPS_COUNT = 4;
/** Height per group item including spacing (in pixels) */
const GROUP_ITEM_HEIGHT = 34;
/** Base height for header, padding, button, and spacing (in pixels) */
const BASE_CARD_HEIGHT = 180; // Header + padding + button space

export const ACCOUNT_GROUPS_CONFIG = {
  /** Number of groups visible before scrolling (scroll when more than this many groups) */
  VISIBLE_GROUPS_COUNT,
  /** When groups.length > VISIBLE_GROUPS_COUNT, scrolling is enabled */
  SCROLL_THRESHOLD: VISIBLE_GROUPS_COUNT + 1,
  /** Base card height for header and padding (in pixels) */
  BASE_CARD_HEIGHT,
  /** Height per group item including spacing (in pixels) */
  GROUP_ITEM_HEIGHT,
  /** Max height of the scrollable list when scrolling is enabled (shows VISIBLE_GROUPS_COUNT groups) */
  LIST_MAX_HEIGHT_WHEN_SCROLL: VISIBLE_GROUPS_COUNT * GROUP_ITEM_HEIGHT,
  /** @deprecated Use LIST_MAX_HEIGHT_WHEN_SCROLL for the list container */
  CARD_HEIGHT_WITH_SCROLL: BASE_CARD_HEIGHT + (VISIBLE_GROUPS_COUNT * GROUP_ITEM_HEIGHT),
} as const;

/**
 * Account Settings Configuration
 */
export const ACCOUNT_SETTINGS_CONFIG = {
  accountGroups: ACCOUNT_GROUPS_CONFIG,
} as const;

/**
 * Workspace Switching Configuration
 */
export const WORKSPACE_SWITCHING_CONFIG = {
  /** Delay in milliseconds to show workspace switching transition screen */
  SWITCHING_DELAY_MS: 1000, // Increased to make transition more noticeable
} as const;
